import './current-frontend.css';
import './soft-minimal.css';
async function start() {
  if (import.meta.env.DEV && new URLSearchParams(location.search).has('qa')) await import('../../tests/qa-session.js');
  await import('./current-frontend.js');
}
void start();
